import { Redemption, RedemptionFragment } from '../redemption.types'

export const SingleCodeRedemptionBlockFragment: RedemptionFragment = {
  name: 'singleCodeRedemption',
  partialFragment: `
    ...on SingleCodeRedemption {
      id
      blockType
      excludedPlatforms {
        ios
        android
        web
      }
    }
  `,
}

export const SingleCodeRedemptionBlockType = 'singleCodeRedemption'

export interface SingleCodeRedemptionBlock extends Redemption {
  blockType: typeof SingleCodeRedemptionBlockType
}
